import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

function EditItemDescriptionModal(props) {
  const [c_name, setCname] = useState(props.editData.keyword);

  const updateItemHandler = (e) => {
    let body = {
      id:props.editData.id,
      keyword: c_name.trim()
    };
    PostApiWithAuthorizationAction("item-descriptions/save-data", body)
      .then((res) => {
        props.reload();
        props.toggle(body);
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } 
      });
  };
  return (
    <Modal isOpen={props.show} toggle={props.toggle} autoFocus={false}>
      <ModalHeader toggle={props.toggle}>Save Item</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="form-control-label" for="c_name">Keyword</Label>
          <Input
            id="c_name"
            type="text"
            placeholder="Keyword"
            value={c_name}
            onChange={(e) => setCname(e.target.value)}
            autoFocus={true}/>
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
        id="update-btn"
          color="primary"
          onClick={updateItemHandler}
          disabled={c_name.length === 0}
        >
          {props.editData.id == 0 ? 'Create' : 'Update'}
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditItemDescriptionModal;
